import { Typography } from "@mui/material";

import STRINGS from "../../utils/strings";

export default function CustomAccordionSummary({ accordionItem }) {
  const data = accordionItem?.data ?? null;
  const title = data?.title ?? STRINGS.defaultTitle;

  return (
    <div className="flex items-center w-full h-full px-0 py-4">
      <div className="flex flex-col items-center justify-center">
        <div className="flex flex-row items-center justify-between w-full h-full">
          {accordionItem && accordionItem?.expandedAccordions.length === 0 ? (
            <div className="flex items-center justify-center w-full h-full px-4">
              <Typography className="text-3xl text-blue-700">
                <span className="font-semibold text-black">{title}</span>
              </Typography>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}
